import { useContext, useEffect, useState } from 'react';
import { DialogContext } from '../../context/DialogContext';
import { TestingHqContext } from '../../context/TestingHqContext';
import { TestingContext } from '../../context/TestingContext';

import ListBody from '../../components/list/ListBody';
import { get_testing_schedule_list, get_testing_place_list, get_testing_accept_summary } from '../../utils/restapi';
import { getCurrentRegularTesting } from '../../utils/currentTesting';
import './list.css';
import TestingPrintAcceptList from './accept_list';
import TestingPrintSeatMapTeacher from './seat_map_teacher';
import TestingPrintSeatMapUser from './seat_map_user';

const TestingPrintList = () => {
  const { testingHqs } = useContext(TestingHqContext);
  const { testingObj, setTestingObj } = useContext(TestingContext);

  const { openDialog, closeDialog } = useContext(DialogContext);

  // 시험유형 관련 상태만 유지
  const [testingTypes, setTestingTypes] = useState([]);
  const [testings, setTestings] = useState([]);
  const [testingSchedules, setTestingSchedules] = useState([]);
  const [testingScheduleObj, setTestingScheduleObj] = useState(null);
  const [testingHqObj, setTestingHqObj] = useState(null);

  // 목록
  const [items, setItems] = useState([]);
  
  // 정렬 관련 상태
  const [sort, setSort] = useState('');
  const [desc, setDesc] = useState('');

  // 이번 회차(정기시험 1건)만 로드해서 고정한다. 지난 회차는 선택할 수 없다.
  const getCurrentTesting = async () => {
    try {
      const { types, regularType, testing } = await getCurrentRegularTesting();
      setTestingTypes(types);

      if (!regularType?.code || !testing) {
        setTestings([]);
        setTestingObj(null);
        return;
      }

      setTestings([testing]);
      setTestingObj({ ...testing, type: regularType.code });
    } catch (error) {
      console.error("Error fetching current testing:", error);
      setTestings([]);
    }
  };

  // 시험 일정에 대한 데이터 가져오기
  const getTestingSchedules = async (testing_id) => {
    console.log('[getTestingSchedules] testing_id : ', testing_id);
    if (!testing_id) {
      setTestingSchedules([]);
      return;
    }
    try {
      const response = await get_testing_schedule_list({ testing_id });
      console.log("getTestingSchedules response:", response);
      setTestingSchedules(response.lists);
      if (response.lists.length === 1) setTestingScheduleObj(response.lists[0]);
    } catch (error) {
      setTestingSchedules([]);
    }
  };

  const handleGetData = async (params = {}) => {
    console.log('testingObj :', testingObj);
    console.log('testingHqs :', testingHqs);
    console.log('handleGetData called with params:', params);
    if (!testingObj || !testingObj.testing_id || testingHqs.length <= 0 || !testingScheduleObj || !testingScheduleObj.testing_schedule_id) {
      setItems([]);
      return;
    }

    const json = {
      testing_id: testingObj.testing_id,
      testing_hq_code: testingHqObj ? testingHqObj.code : undefined,
      page: params?.page || 1,
      rowsPerPage: params?.rowsPerPage || 20,
      sort: params?.sort || 'a_testing_place_id',
      desc: params?.desc || 'desc',
      hcodes: testingHqs.map(hq => hq.code).join(','),    
      ...params
    };

    console.log("handleGetData params:", json);

    try {
      const response = await get_testing_place_list(json);
      console.log("handleGetData response:", response);
      const places = response.lists || [];

      // 고사실수·접수인원은 지역본부(hcodes)와 무관하게 고사장·일정 기준으로 전체 집계해서 덮어쓴다.
      const summaryMap = new Map();
      try {
        const summaryResponse = await get_testing_accept_summary({
          testing_id: testingObj.testing_id,
          testing_schedule_id: testingScheduleObj.testing_schedule_id,
        });
        (summaryResponse.lists || []).forEach((row) => {
          summaryMap.set(Number(row.testing_place_id), row);
        });
      } catch (summaryError) {
        console.error("Error fetching accept summary:", summaryError);
      }

      const merged = places.map((place) => {
        const summary = summaryMap.get(Number(place.testing_place_id));
        return summary ? { ...place, rooms: summary.rooms, accept_users: summary.accept_users } : place;
      });

      setItems(merged);
      return response;
    } catch (error) {
      console.error("Error fetching testing places:", error);
      setItems([]);
      return { lists: [], total: 0, totalPages: 0 };
    }
  };

  // 시험 일정 변경
  const handleTestingScheduleChanged = (e) => {
    console.log('[handleTestingScheduleChanged] called');
    const selectedValue = e.target.value;
    const selectedTestingSchedule = testingSchedules.find(obj => obj.testing_schedule_id === parseInt(selectedValue));
    setTestingScheduleObj(selectedTestingSchedule || null);
  }

  // 시험 지역본부 변경
  const handleTestingHqChange = (e) => {
    console.log('[handleTestingHqChange] called');
    const selectedValue = e.target.value;
    const selectedHq = testingHqs.find(hq => hq.code === selectedValue);
    setTestingHqObj(selectedHq || null);
  };

  // 응시자명단
  const handleAcceptListClick = (item) => {
    const customStyles = {
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
      },
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '0',
        border: 'none',
        borderRadius: '8px',
        maxWidth: '90vw',
        maxHeight: '90vh',
        overflow: 'auto'
      },
    };

    const handleClose = () => {
      closeDialog();
    };

    openDialog(
      <TestingPrintAcceptList
        testingPlaceObj={item}
        testingScheduleObj={testingScheduleObj}
        onClose={handleClose}
      />, 
      customStyles
    );
  };

  // 좌석배치도(감독관용)
  const handleSeatMapForTeacherClick = (item) => {
    const customStyles = {
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
      },
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '0',
        border: 'none',
        borderRadius: '8px',
        maxWidth: '90vw',
        maxHeight: '90vh',
        overflow: 'auto'
      },
    };

    const handleClose = () => {
      closeDialog();
    };

    openDialog(
      <TestingPrintSeatMapTeacher
        testingPlaceObj={item}
        testingScheduleObj={testingScheduleObj}
        onClose={handleClose}
      />, 
      customStyles
    );
  };

  // 좌석배치도(부착용)
  const handleSeatMapForUserClick = (item) => {
    const customStyles = {
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
      },
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '0',
        border: 'none',
        borderRadius: '8px',
        maxWidth: '90vw',
        maxHeight: '90vh',
        overflow: 'auto'
      },
    };

    const handleClose = () => {
      closeDialog();
    };

    openDialog(
      <TestingPrintSeatMapUser
        testingPlaceObj={item}
        testingScheduleObj={testingScheduleObj}
        onClose={handleClose}
      />, 
      customStyles
    );
  };

  // headers에 renderCell 함수를 포함시킴
  const headers = [
    { 
      name: 'NO.', 
      value: 'a_testing_place_id',
      renderCell: (item) => item.testing_place_id
    },
    { 
      name: '고사장명', 
      value: 'a_name',
      renderCell: (item) => item.name
    },
    {
      name: '고사실수',
      value: 'a_rooms',
      renderCell: (item) => item.rooms,
    },
    { 
      name: '접수인원', 
      value: 'a_accept_users',
      renderCell: (item) => item.accept_users,
    },
    { 
      name: '비고', 
      value: '',
      renderCell: (item) => (
        <>
          <button onClick={(e) => handleAcceptListClick(item)}>응시자명단</button>
          <button onClick={(e) => handleSeatMapForTeacherClick(item)}>좌석배치도(감독관용)</button>
          <button onClick={(e) => handleSeatMapForUserClick(item)}>좌석배치도(부착용)</button>
        </>
      )
    }
  ];

  // 컴포넌트가 처음 마운트될 때 이번 회차 로드
  useEffect(() => {
    getCurrentTesting();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (testingObj && testingObj.testing_id) {
      handleGetData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testingObj?.testing_id]);

  useEffect(() => {
    if (testingObj && testingObj.testing_id) {
      getTestingSchedules(testingObj.testing_id);
    } else {
      setTestingSchedules([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testingObj?.testing_id]);

  useEffect(() => {
    console.log("testingScheduleObj changed:", testingScheduleObj);
    if (testingScheduleObj && testingScheduleObj.testing_schedule_id) {
      handleGetData();
    } else {
      setItems([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testingScheduleObj?.testing_schedule_id]);

  useEffect(() => {
    if (testingHqs && testingHqs.length > 0) {
      handleGetData();
    } else {
      setItems([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testingHqs?.length]);

  return (
    <div id="testing_print_list">
      <div className="head">
        <h1>응시자명단 및 좌석배치도</h1>
      </div>
      <div className="body">
        <div className="top">
          <ul className="form">
            <li>
              <label>구분</label>
              <span>
                <select value={testingObj?.type || ''} disabled>
                  <option value="">▒ 선택 ▒</option>
                  {testingTypes
                    .filter(obj => `${obj?.nickname || ''}${obj?.name || ''}`.includes('정기'))
                    .map((obj, index) => (
                    <option key={index} value={obj.code}>
                      {obj.nickname || obj.name}
                    </option>
                  ))}
                </select>
              </span>
            </li>
            <li>
              <label>시험</label>
              <span>
                <select value={testingObj?.testing_id || ''} disabled>
                  <option value="">▒ 선택 ▒</option>
                  {testings.map((obj, index) => (
                    <option key={index} value={obj.testing_id}>
                      {obj.title}
                    </option>
                  ))}
                </select>
              </span>
            </li>
            <li>
              <label>일정</label>
              <span>
                <select value={testingScheduleObj?.testing_schedule_id || 0} onChange={handleTestingScheduleChanged}>
                  <option value="">▒ 일정 ▒</option>
                  {testingSchedules.map((obj, index) => (
                    <option key={index} value={obj.testing_schedule_id}>
                      {obj.testStartDate} ~ {obj.testStopDate}
                    </option>
                  ))}
                </select>
              </span>
            </li>
            <li>
              <label>지역본부</label>
              <span>
                <select value={testingHqObj?.code || ''} onChange={handleTestingHqChange}>
                  <option value="">▒ 선택 ▒</option>
                  {testingHqs.map((hq, index) => (
                    <option key={index} value={hq.code}>
                      {hq.name}
                    </option>
                  ))}
                </select>
              </span>
            </li>
          </ul>
          <ListBody
            headers={headers}
            items={items}
            sort={sort}
            desc={desc}
            setSort={setSort}
            setDesc={setDesc}
            className="place_table"
          />
        </div>
      </div>
    </div>
  );
};

export default TestingPrintList;
